import React, { useState } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Alert,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom'; // For navigation
import '../../assets/css/LoginForm.css'; // Import custom CSS for styling
import bg from "../../assets/images/bg.jpeg";
import logo from "../../assets/images/logo.png";
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { authActions } from '../../sagas/authSlice';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { FaLock, FaUser } from 'react-icons/fa';

const LoginForm = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Hook for navigation
  const dispatch = useDispatch();
  const { t } = useTranslation(); // Translation
  const formik = useFormik({
    initialValues: { username: "", password: "" },
    onSubmit: (values) => {
      dispatch(
        authActions.loginRequest({
          user: values,
          onSuccess: (data) => {
            navigate("/dashboard");
          },
          onError: (error) => {
            Swal.fire({
              icon: 'error',
              title: t('auth.loginError'),
            });
          }
        })
      );
    },
  });


  return (
    <div className="auth-wrapper">
      <div
        className="auth-background"
        style={{
          backgroundImage: `url(${bg})`
        }}
      />
      <div className="auth-overlay" />

      <Container className="position-relative">
        <Row className="justify-content-end">
          <Col xs={12} sm={8} md={6} lg={5} xl={4}>
            <Card className="login-card">
              <CardBody className="p-4">
                {/* Header */}
                <div className="text-center mb-4">
                  <img
                    src={logo}
                    alt="MatjarPos"
                    className="login-logo"
                  />
                  <div className="logo-underline" />
                  <h3 className="welcome-text">
                    {t('auth.welcomeSignup')}
                  </h3>
                  <p className="login-subtitle">
                    {t('auth.loginPrompt')}
                  </p>
                </div>

                {/* Form */}
                <Form onSubmit={formik.handleSubmit}>
                  <FormGroup className="form-group">
                    <Label className="form-label">
                      {t('auth.username')}
                    </Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <FaUser />
                      </span>
                      <Input
                        type="text"
                        id="username"
                        placeholder={t('auth.usernamePlaceholder')}
                        {...formik.getFieldProps('username')}
                        invalid={formik.touched.username && formik.errors.username}
                      />
                    </div>
                  </FormGroup>

                  <FormGroup className="form-group">
                    <Label className="form-label">
                      {t('auth.password')}
                    </Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <FaLock />
                      </span>
                      <Input
                        type="password"
                        id="password"
                        placeholder={t('auth.passwordPlaceholder')}
                        {...formik.getFieldProps('password')}
                        invalid={formik.touched.password && formik.errors.password}
                      />
                    </div>
                  </FormGroup>

                  <Button
                    block
                    type="submit"
                    className="login-button"
                  >
                    {t('auth.loginButton')}
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default LoginForm;
